import { createSlice } from '@reduxjs/toolkit';
import { Dealer } from '../../types/dealerTypes';
import { setFetching } from '../utils';
import { fetchDealer, updateDealer } from './thunks';

export const dealerSlice = createSlice({
  name: 'dealer',
  initialState: {
    fetching: false,
    dealer: null as Dealer | null,
  },
  reducers: {
    clearDealer: (state) => {
      state.dealer = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDealer.pending, (state) => {
      state.fetching = true;
      state.dealer = null;
    });
    builder.addCase(fetchDealer.rejected, setFetching(false));
    builder.addCase(fetchDealer.fulfilled, (state, action) => {
      state.fetching = false;
      state.dealer = action.payload;
    });

    builder.addCase(updateDealer.pending, setFetching());
    builder.addCase(updateDealer.rejected, setFetching(false));
    builder.addCase(updateDealer.fulfilled, (state, action) => {
      state.fetching = false;
      state.dealer = action.payload;
    });
  },
});
